import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS,ANONYMOUS_AUTH_SUCCESS, SET_ANONYMOUS_AUTH, AUTH_LOGOUT,AUTH_RECOVER_PASSWORD , AUTH_RESET_PASSWORD,AUTH_SET_TOKEN_VALID,AUTH_VALIDATE_TOKEN, AUTH_GET_ME,AUTH_GET_CUSTOMER_PROFILE,SET_CUSTOMER_PROFILES,SET_CUSTOMER_PROFILE, AUTH_SET_CUSTOMER_PROFILE, ANONYMOUS_AUTH_REQUEST, AUTH_SET_PORTAUS_COMPANY, AUTH_SET_SYS_PROP} from '../actions/auth'
import { USER_REQUEST } from '../actions/user'
import serviceAuth from '@/services/API/user'
import serviceCustomer from '@/services/API/customer'
import systemAPI from '@/services/API/system';
import axios from 'axios';
import _ from 'lodash';
import jwt from 'jsonwebtoken';

const state = {
  token: localStorage.getItem('access-token') || '',
  status: '',
  hasLoadedOnce: false,
  passwordRecoveryLoading:false,
  passwordResetLoading:false,
  tokenValid:false,
  customerProfiles : [],
  customerProfile :null,
  anonymous_auth : false,
  portausCompany: null,
  currentUser: null,
}

const getters = {
  isAuthenticated: state => !!state.token,
  user : (state, getters) => {
    if(getters.isAuthenticated){
        return localStorage.getItem('user')!=null ? JSON.parse(localStorage.getItem('user')) : null;
    }else{
      return null;
    }
  },
  authenticatedUser: state => state.currentUser,
  authStatus: state => state.status,
  customerProfiles : state=> state.customerProfiles,
  customerProfile : state=> state.customerProfile,
  isAnonymousAuth : state => state.anonymous_auth,
  portausCompanyName : state => _.get(state, 'portausCompany.name'),
  portausCompanyId : state => _.get(state, 'portausCompany.id'),
  getCurrentPortausCompany: state => state.portausCompany,
  portausCompanyEndFiscalMonth: state => _.get(state, 'portausCompany.fiscal_end_month'),
  portausCompanyEndFiscalDay: state => _.get(state, 'portausCompany.fiscal_end_day'),
  isMultiplePortausCompanies: (state, getters) => _.size(_.get(getters.user, 'portausCompanies')) > 1,
  getPortausCompanies: (state, getters) => _.get(getters.user, 'portausCompanies'),
  hasAccessToCompany: (state, getters) => companyId => _.find(getters.getPortausCompanies, cie => cie.id === companyId) != null,
  getCurrentUserId: state => _.get(state, 'currentUser.id'),
  isSAQProcessModuleactive: state => _.get(state,'portausCompany.saq_process_module_ind') === true,
  isInvoicingModuleactive: state => _.get(state,'portausCompany.invoicing_module_active') === true,
  isExternalAccountAPIModuleactive: state => _.get(state,'portausCompany.external_account_api_active') === true,
  isAutomaticDelayOnReservationActivated: state => _.get(state,'portausCompany.automatic_delay_reservation') === true,
  getReportCustomization: state => _.get(state,'portausCompany.report_customization'),
  isBlockReportExceptAdmin: state => _.get(state,'portausCompany.block_report_except_admin') === true,
  isStrictFilteredByRep: state => _.get(state,'portausCompany.strict_rep_filter') === true,
  isCurrentUserRep: state => _.find(_.get(state, 'currentUser.roles'), r => r.role_name === 'Rep') != null,
  isRepCanModify: state => _.get(state,'portausCompany.rep_can_modify'),
  isCurrentUserAdmin: state => _.find(_.get(state, 'currentUser.roles'), r => r.role_name === 'Super Admin') != null,
}

const actions = {
  [ANONYMOUS_AUTH_REQUEST]: ({commit, dispatch}, token) => {
    return serviceAuth.createPortausContextByExternalToken(token)
      .then((portausContextToken) => {

        commit(SET_ANONYMOUS_AUTH, true);
        localStorage.setItem('access-token', null);
        localStorage.setItem("user", null);
        // console.log('portausContextToken : ', portausContextToken);
        axios.defaults.headers.common['X-Portaus-Context'] = portausContextToken.token;
        let  portausTokenDecoded = null;
        try{
          portausTokenDecoded = jwt.verify(portausContextToken.token, process.env.VUE_APP_APP_SECRET);

          if (_.get(portausTokenDecoded, 'languageLongCode') != null) {
            dispatch('changeLocale', _.get(portausTokenDecoded, 'languageLongCode') , { root: true });
          }
        } catch (err) {
          console.log(err);
        }
        return serviceAuth.anonymous_auth(token)
          .then(resp => {
            // console.log('resp : ', resp);
            localStorage.setItem('access-token', resp.data.accessToken);
            // localStorage.setItem('portaus-context', resp.data.portausContextToken);
            localStorage.setItem("user", JSON.stringify(resp.data.user));
            commit(ANONYMOUS_AUTH_SUCCESS,resp);
            axios.defaults.headers.common['Authorization'] = resp.data.accessToken;
            // axios.defaults.headers.common['X-Portaus-Context'] = resp.data.portausContextToken;
            return dispatch(AUTH_SET_CUSTOMER_PROFILE,{id:resp.data.user.customerId})
            .then(()=>{
              return resp;
            })
          })
          .catch(err => {
            commit(AUTH_ERROR, err)
            localStorage.removeItem('access-token')
            return Promise.reject(err);
          })
      })
  },
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      serviceAuth.auth(user)
      .then(resp => {
        localStorage.setItem('access-token', resp.data.accessToken);
        localStorage.setItem('portaus-context', resp.data.portausContextToken);
        localStorage.setItem("user", JSON.stringify(resp.data.user));
        axios.defaults.headers.common['Authorization'] = resp.data.accessToken;
        axios.defaults.headers.common['X-Portaus-Context'] =  _.get(resp, 'data.portausContextToken');
        dispatch(AUTH_SET_PORTAUS_COMPANY, resp.data.portausCompany);
        dispatch(AUTH_SET_SYS_PROP);
        if (_.get(resp, 'data.user.language.long_code') != null) {
          dispatch('changeLocale', _.get(resp, 'data.user.language.long_code') , { root: true });
        }
        
        if(!resp.data.user.is_admin){
          return dispatch(AUTH_GET_CUSTOMER_PROFILE)
            .then(()=>{
              commit(AUTH_SUCCESS, resp);
              resolve(resp);
            })
        }else{
          commit(AUTH_SUCCESS, resp);
          resolve(resp);
        }
      })
      .catch(err => {
        commit(AUTH_ERROR, err)
        localStorage.removeItem('access-token')
        reject(err)
      })
    })
  },
  [AUTH_GET_ME] : ({commit, dispatch})=>{
    return serviceAuth.me()
      .then(user=>{
        // console.log(user);
        localStorage.setItem('access-token', user.accessToken);
        localStorage.setItem("user", JSON.stringify(user.user));
        localStorage.setItem('portaus-context', user.portausContextToken);
        axios.defaults.headers.common['Authorization'] = user.accessToken;
        axios.defaults.headers.common['X-Portaus-Context'] = user.portausContextToken;
        dispatch(AUTH_SET_PORTAUS_COMPANY, user.portausCompany);
        let resp = {};
        resp.data = user;
        commit(AUTH_SUCCESS, resp );
        return user;
      })
  },
  [AUTH_GET_CUSTOMER_PROFILE] : ({commit})=>{
    let userId = JSON.parse(localStorage.user).id;
    return serviceCustomer.fetchCustomers({contactId:userId,paging:'no'})
      .then(customers=>{
        commit('SET_CUSTOMER_PROFILES',customers);
        if(customers){
          if(customers.length==1){
            commit('SET_CUSTOMER_PROFILE', customers[0]);
          }
          return customers;
        }else {
          return null;
        }

      })
  },
  [AUTH_SET_CUSTOMER_PROFILE] : ({commit},customer)=>{
    commit('SET_CUSTOMER_PROFILE',customer);
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      localStorage.removeItem('access-token')
      localStorage.removeItem('profileId')
      resolve()
    })
  },
  [AUTH_RECOVER_PASSWORD] : ({commit, dispatch}, email)=>{
    commit('AUTH_RECOVER_PASSWORD_LOADING',true)
    return serviceAuth.sendRecoveryPasswordEmail(email)
      .then(()=>{
        commit('AUTH_RECOVER_PASSWORD_LOADING',false)
      })
  },
  [AUTH_VALIDATE_TOKEN] : ({commit, dispatch}, token)=>{
    commit('AUTH_PASSWORD_RESET_LOADING',true)
    return serviceAuth.validateToken(token)
      .then(()=>{
        commit('AUTH_SET_TOKEN_VALID',true);
        commit('AUTH_PASSWORD_RESET_LOADING',false)
      }).catch(err=>{
        commit('AUTH_SET_TOKEN_VALID',false);
        return err;
      })
  },
  [AUTH_RESET_PASSWORD] : ({commit, dispatch}, {password, token})=>{
    commit('AUTH_PASSWORD_RESET_LOADING',true)
    return serviceAuth.resetPassword(token, password);
  },
  [AUTH_SET_TOKEN_VALID] : ({commit, dispatch}, tokenValid)=>{
    commit('AUTH_SET_TOKEN_VALID',tokenValid)
  },
  [AUTH_SET_SYS_PROP] : () => {
    systemAPI.getSysProp()
      .then((sysprops) => {
        _.forEach(sysprops, prop=>{
            localStorage.setItem(prop.key,JSON.stringify(prop.value));
          })
      })
  },
  [AUTH_SET_PORTAUS_COMPANY] : ({commit, dispatch}, portausCompany)=>{
    dispatch('invoices/invalidateInvoiceList');
    commit('AUTH_SET_PORTAUS_COMPANY',portausCompany)
  },
}

const mutations = {
  AUTH_SET_PORTAUS_COMPANY: (state, portausCompany) =>{
     state.portausCompany = portausCompany;
  },
  [ANONYMOUS_AUTH_REQUEST]: (state) =>{
     state.status = 'loading'
  },
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [SET_ANONYMOUS_AUTH] : (state, anonymousauth) => {
    state.anonymous_auth = anonymousauth;
  },
  [ANONYMOUS_AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.anonymous_auth = true;
    state.token = resp.data.accessToken
    state.refreshToken = resp.data.refreshToken;
    state.hasLoadedOnce = true
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.anonymous_auth = false;
    state.token = resp.data.accessToken
    state.refreshToken = resp.data.refreshToken;
    state.currentUser = resp.data.user;
    state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
    state.anonymous_auth = null;
    state.customerProfiles=[];
    state.customerProfile=null;
  },
  ['AUTH_RECOVER_PASSWORD_LOADING'] : (state, passwordRecoveryLoading)=>{
    state.passwordRecoveryLoading=passwordRecoveryLoading
  },
  ['AUTH_PASSWORD_RESET_LOADING'] : (state, passwordResetLoading)=>{
    state.passwordResetLoading=passwordResetLoading;
  },
  ['AUTH_SET_TOKEN_VALID'] : (state, tokenValid)=>{
    state.tokenValid=tokenValid;
  },
  ['SET_CUSTOMER_PROFILES'] : (state, customerProfiles)=>{
    state.customerProfiles=customerProfiles;
  },
  ['SET_CUSTOMER_PROFILE'] : (state, customerProfile)=>{
    state.customerProfile=customerProfile;
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
